<template>
  <div class="cooperation">
    <div class="sutpContentPanel flex-center-start">
      <!-- 左边 -->
      <div class="sutpLeft sutpIem">
        <div
          class="sutpLeftItem"
          v-for="(item, index) in sutpLeftItem"
          :key="index"
        >
          <div class="sutpLeftItemTiltle font-size-20">{{ item.title }}</div>
          <div
            class="sutpLeftSubItem"
            v-for="(item1, index1) in item.sutpLeftSubItem"
            :key="index1"
          >
            <div class="sutpLeftSubItemTitle">{{ item1.subTitle }}</div>
            <div
              class="sutpLeftSubItemMobilePanel flex-center-start font-size-14"
              v-for="(item2, index2) in item1.sutpLeftMobile"
              :key="index2"
            >
              <span class="sutpLeftSubItemName">{{ item2.name }}</span>
              <span class="sutpLeftSubItemMobile">{{ item2.mobile }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间 -->

      <div class="sutpCenter">
        <div
          class="sutpCenterItem sutpIem"
          v-for="(item, index) in sutpCenterItem"
          :key="index"
        >
          <div class="sutpCenterItemTitle font-size-20">{{ item.title }}</div>
          <div
            class="sutpCenterItemWechatPanel font-size-14"
            v-for="(item1, index1) in item.wechatItem"
            :key="index1"
          >
            <span class="sutpCenterItemName">{{ item1.name }}</span>
            <span class="sutpCenterItemWechat">{{ item1.wechat }}</span>
          </div>
        </div>
      </div>
      <!-- 右边 -->

      <div class="sutpRight">
        <div class="sutpRightTopItem sutpIem flex-center-center">
          <img src="@/images/com/logo.png" alt="" />
        </div>
        <div
          class="sutpRightItem sutpIem flex-center-around"
          v-for="(item, index) in sutpRightItem"
          :key="index"
        >
          <div class="sutpRightItemText">
            <div class="sutpRightItemTextTitle font-size-20">
              {{ item.title }}
            </div>
          </div>
          <div class="sutpRightItemQrcode flex-column-center-center">
            <img :src="item.img" alt />
            <div class="sutpRightItemTextSubtitle">{{ item.subTitle }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sutpLeftItem: [
        {
          title: "赞助、商务合作请联系",
          sutpLeftSubItem: [
            {
              subTitle: "游戏、电竞板块",
              sutpLeftMobile: [
                { name: "文静", mobile: "Wechat: mutou_kiki" },
                // { name: "西瓜", mobile: "18659030320" },
                // { name: "林晗", mobile: "18823803517" },
              ],
            },
            {
              subTitle: "XR、AI板块",
              sutpLeftMobile: [
                // { name: "西瓜", mobile: "18659030320" },
                { name: "六六", mobile: "Wechat: lu0130611" },
              ],
            },
          ],
        },
      ],
      sutpCenterItem: [
        {
          title: "项目合作请联系",
          wechatItem: [
            { name: "Cos", wechat: "  Wechat: xxhh304 " },
            // { name: "晋羽", wechat: "Wechat: silver9393" },
          ],
        },
        // {
        //   title: "金陀螺奖报名参评/投票",
        //   wechatItem: [
        //     { name: "大冬", wechat: "Wechat：sylvia_lee_lee" },
        //     { name: "王超", wechat: "Wechat：jkwangchao" },
        //     { name: "敏怡", wechat: "Wechat：miyee113" },
        //   ],
        // },
      ],
      sutpRightItem: [
        // {
        //   title: "第六届金陀螺参评报名投票",
        //   subTitle: "码上参评投票 ",
        //   img: require("@/images/com/cptp.png"),
        // },
        {
          title: "FBEC2025大会报名通道",
          subTitle: "扫码报名参会",
          img: require("@/images/com/bmch.png"),
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.cooperation {
  .sutpContentPanel {
    height: 4.7rem;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: saturate(180%) blur(6px);
    -webkit-backdrop-filter: saturate(180%) blur(6px);
    -moz-backdrop-filter: saturate(180%) blur(6px);
    -o-backdrop-filter: saturate(180%) blur(6px);
  }
  .sutpIem {
    border-radius: 0.04rem;
  }
  .sutpLeftSubItemName,
  .sutpCenterItemName {
    padding-right: 0.16rem;
  }
  .sutpRightTopItem {
    height: 2.28rem;
    img {
      width: 3rem;
      height: 0.63rem;
    }
  }
  .sutpCenterItem {
    height: 100%;
  }
  .sutpRightItem {
    height: 2.28rem;
  }
  .sutpCenterItem:not(:first-child),
  .sutpRightItem:not(:first-child) {
    margin-top: 0.14rem;
  }
  // 左
  .sutpLeft {
    width: 2.7rem;
    height: 100%;
    text-align: left;
  }
  .sutpLeftItem {
    padding: 0.4rem 0 0 0.16rem;
  }

  .sutpLeftSubItem {
    margin-top: 0.26rem;
  }

  .sutpLeftSubItemTitle {
    font-size: 0.16rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    padding-bottom: 0.12rem;
    text-align: left;
  }
  .sutpLeftSubItemMobilePanel:not(:first-child) {
    margin-top: 0.02rem;
  }
  // 中
  .sutpCenter {
    margin: 0 0.14rem;
    width: 2.69rem;
    text-align: left;
    height: 100%;
  }
  .sutpCenterItem {
    padding: 0 0 0 0.16rem;
  }
  .sutpCenterItemTitle {
    padding: 0.41rem 0 0.24rem 0;
  }
  .sutpCenterItemWechatPanel:not(:first-child) {
    margin-top: 0.02rem;
  }
  // 右
  .sutpRight {
    width: 5.53rem;
    height: 100%;
  }

  .sutpRightItem {
    padding: 0 0.18rem 0 0.16rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cooperation.vue